import FetchData from '@shared/utils/fetchData/fetchData';

export const addProductToCart = async (products: Array<{ productId: string; quantity: number }>) => {
  return await FetchData.post<{ message: string }>('cart', {
    body: JSON.stringify({ products })
  });
};
